/* eslint-disable @typescript-eslint/no-explicit-any */
import classNames from 'classnames'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import { CardContextProvider } from './card-context'
import type { CardCardProps } from './types'
import { PanePrivate } from '../_layouts/pane/pane'

const CardCard: FC<CardCardProps> = React.forwardRef<
  HTMLDivElement,
  CardCardProps
>(function CardCard(props, ref) {
  const {
    variant,
    className,
    a11yDescriptionId,
    a11yTitleId,
    useContext,
    border,
    children,
    ...rest
  } = props
  const useStyledBorderProps =
    border === 'shadow' || typeof border === 'boolean'
  const baseStyles = useMemo(
    () => ({
      border: useStyledBorderProps ? undefined : border
    }),
    [border, useStyledBorderProps]
  )

  return (
    <PanePrivate
      ref={ref}
      __themeKey="cards"
      className={classNames(
        {
          'csg-tui-card-card': true
        },
        className
      )}
      variant={useContext && variant ? `${variant}.card` : variant ?? 'card'}
      square={!(rest.borderRadius || rest.sx?.borderRadius)}
      aria-describedby={a11yDescriptionId}
      aria-labelledby={a11yTitleId}
      styledBorder={useStyledBorderProps ? border : undefined}
      {...rest}
      __css={baseStyles}
    >
      {useContext && variant ? (
        <CardContextProvider variant={variant}>{children}</CardContextProvider>
      ) : (
        children
      )}
    </PanePrivate>
  )
})

export default CardCard
